module.exports = __webpack_public_path__ + "static/media/bot.028143ff.png";